import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import type { Router } from 'vue-router'

import { env } from '@/config/env'

// All of staging, most of production. Reduce here if traces get noisy.
const SAMPLE_RATES: Record<string, number> = {
  environment: 0.0,
  staging: 1.0,
  production: 0.6,
}

// Continue browser traces into the OMR backends this app calls (myomr, platform-api,
// tickets, hi, and the reviews and jobs APIs), so a browser error and the backend
// error it caused land on one trace. Scoped to *.omr.* on purpose: propagating to
// third parties leaks trace ids and can trip their CORS preflights. The host class
// allows dots because api.reviews.omr.com and api.jobs.omr.com carry two labels; the
// trailing anchor still rejects https://my.omr.com.example/.
export const TRACE_PROPAGATION_TARGETS = [/^\//, /^https:\/\/(?!serve\.omr\.|cdn77\.omr\.)[a-z0-9.-]+\.omr\.(com|ninja|io)(\/|$)/]

export function sentryOptions(router: Router) {
  return {
    enabled: env !== 'environment',
    environment: env === 'environment' ? 'development' : env,
    dsn: 'https://74c5198f96a641cd88a1e8b0ff19fc82@o4504020351778816.ingest.sentry.io/4504576367001600',
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracePropagationTargets: TRACE_PROPAGATION_TARGETS,
    tracesSampleRate: SAMPLE_RATES[env],
  }
}

export function initSentry(app: App, router: Router) {
  Sentry.init({ app, ...sentryOptions(router) })
}
